import {CommonMessages} from '../common.messages';

export const PanelSettingsOperatorsEditMessages = {
    GetOperatorFailed: {
        key: 'GetOperatorFailed',
        message: 'Error while communication with the server. Unable to get details for the operator.'
    },
    OperatorNotFound: {
        key: 'OperatorNotFound',
        message: 'Error while communication with the server. Details for the operator doesn\'t exists.'
    },
    GetUserRolesFailed: {
        key: 'GetUserRolesFailed',
        message: 'Error while communication with the server. Unable to get user roles for the operator.'
    },
    UserRolesNotFound: {
        key: 'UserRolesNotFound',
        message: 'Error while communication with the server. User roles for the operator doesn\'t exists.'
    },
    GetRolesFailed: {
        key: 'GetRolesFailed',
        message: 'Error while communication with the server. Unable to get available user roles.'
    },
    RolesNotFound: {
        key: 'RolesNotFound',
        message: 'Error while communication with the server. Available user roles not found.'
    },
    GetStatusTriggersFailed: {
        key: 'GetStatusTriggersFailed',
        message: 'Error while communication with the server. Unable to get available operator statuses.'
    },
    UpdateOperatorFailed: {
        key: 'UpdateOperatorFailed',
        message: 'Error while request processing. Unable to update operator information.'
    },
    UpdateOperatorStatusFailed: {
        key: 'UpdateOperatorStatusFailed',
        message: 'Error while request processing. Unable to update operator status.'
    },
    AssignUserRolesFailed: {
        key: 'AssignUserRolesFailed',
        message: 'Error while request processing. Unable to update operator role.'
    },
    SendOperatorResetPasswordFailed: {
        key: 'SendOperatorResetPasswordFailed',
        message: 'Unable to send <<email>> email to the operator.'
    },
    SendOperatorResetPasswordSucceed: {
        key: 'SendOperatorResetPasswordSucceed',
        message: 'The email for <<email>> is sent successfully.'
    },
    UpdateOperatorSucceed: {
        key: 'UpdateOperatorSucceed',
        message: 'Operator details are successfully updated.'
    },
    ...CommonMessages
};
